<template>
    <a href="#" :class="currentClass">
                <span class="tab-icon">
                    <svg-vue :icon="icon" class="icon"/>
                </span>
        <span class="count">{{ count }}</span>
        <slot/>
    </a>
</template>

<script>
export default {
    name: 'DashboardTab',
    props: [
        'active',
        'icon',
        'count'
    ],
    computed: {
        currentClass() {
            return this.active ? 'active' : '';
        }
    }
};
</script>
